import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/local/AddTerms.css";

const AddTerms = () => {
  const history = useHistory();

  return (
    <>
      <div>
        <div className="terms-container container mt-3">
          {/* Billing Terms */}
          <div className="d-flex justify-content-between align-items-center mt-3 p-3 border rounded">
            <p>billing-terms </p>
            <span>
              Rent per 2 weeks, assembly 65% after delivery dismantling <br />
              35% after delivery and other costs in proportion
            </span>
            <button className="btn-close" aria-label="Close"></button>
          </div>

          {/* Table */}
          <table className="table table-bordered mt-3">
            <thead>
              <tr>
                <th>Facade</th>
                <th>Facade Value</th>
                <th>Duration (weeks)</th>
                <th>Assembly (A)</th>
                <th>Rent (R)</th>
                <th>Disassembly (D)</th>
                <th>Terms</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Front</td>
                <td>€ 0.000.000,00</td>
                <td>2</td>
                <td>€ 0.000.000,00</td>
                <td>€ 0.000.000,00</td>
                <td>€ 0.000.000,00</td>
                <td>3</td>
              </tr>
              <tr>
                <td>Totals</td>
                <td>€ 0.000.000,00</td>
                <td>00</td>
                <td>€ 0.000.000,00</td>
                <td>€ 0.000.000,00</td>
                <td>€ 0.000.000,00</td>
                <td>3</td>
              </tr>
            </tbody>
          </table>

          {/* Create Invoices Button */}
          <div className="text-end">
            <button className="btn btn-primary">Create Invoices</button>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddTerms;
